module.exports = __webpack_public_path__ + "static/img/hhd_vip_01.6d5b8c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/member/hhd_vip_01.jpg
// module id = e2Vo
// module chunks = 1